import { useIntl } from 'react-intl';

import type { MemberDeckPage } from '../lib/deck-page.ts';

export function DeckPageStats({ page }: { page: MemberDeckPage }) {
  const intl = useIntl();
  return (
    <p>
      {intl.formatMessage(
        { id: 'web.deckPage.statsSummary' },
        {
          cardCount: page.member.cardCount,
          everCorrectCount: page.member.everCorrectCount,
          touchedCount: page.member.touchedCount,
          lockedCardCount: page.member.lockedCardCount ?? 0,
        },
      )}
    </p>
  );
}
